import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import { ExpertQuestionSection, SubTextLink, Title } from '../../DTQuestionOrInstruction.styles';
import * as colors from '../../../../../common/colorConstants';
import { trackDecisionTreeTrackingLinkClicked } from '../../../../../../analytics/searchEventAnalytics';
import {
  getCurrentShopifyOrderFromSubscription,
  extractCurrentDecisionTreePath,
} from '../../../../../../extractFromState';

const DTDeliveryQuestionNode = () => {
  const [isLinkClicked, setIsLinkClicked] = useState(false);
  const currentShopifyOrder = useSelector(getCurrentShopifyOrderFromSubscription);
  const decisionTreePath = useSelector(extractCurrentDecisionTreePath);

  const handleLinkClick = () => {
    setIsLinkClicked(true);
    trackDecisionTreeTrackingLinkClicked();
  };

  useEffect(() => {
    setIsLinkClicked(false);
  }, [decisionTreePath, setIsLinkClicked]);

  const renderQuestion = () => (
    <ExpertQuestionSection>
      <Title>Is the last order in the subscription delivered or in-transit?</Title>
      <SubTextLink>
        <a
          onClick={handleLinkClick}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: colors.darkGray9 }}
          href={currentShopifyOrder?.tracking_url}
        >
          Click on this link to see the delivery status
        </a>
      </SubTextLink>
    </ExpertQuestionSection>
  );

  return (
    <DTQuestionOrInstructionView
      titleSection={renderQuestion()}
      options={<ButtonList isButtonDisabled={!isLinkClicked} />}
      loading={false}
    />
  );
};

export default DTDeliveryQuestionNode;
